<section class="modal-cnt" [ngClass]="options.modalClass" cdkTrapFocus>
	<header class="modal-cnt__hd">
		<h4 class="modal-cnt__tl" *ngIf="options.title">{{ options.title }}</h4>
		<button type="button" class="modal-cnt__close def-focus" (click)="onClose()" [title]="'close' | translate">
			<lu-icon icon="times"></lu-icon>
		</button>
	</header>

	<div class="modal-cnt__bd">
		<ng-content></ng-content>
	</div>

	<footer class="modal-cnt__ft modal-cnt__ft--widget" *ngIf="options.primaryActions || options.secondaryActions">
		<div class="secondary">
			<ng-container *ngIf="options.secondaryActions">
				<button
					type="button"
					class="btn"
					[ngClass]="secondaryAction.class || 'btn--default'"
					(click)="secondaryAction.onClick()"
					*ngFor="let secondaryAction of options.secondaryActions"
					[disabled]="secondaryAction.disabled">
					<lu-icon *ngIf="secondaryAction.icon" [icon]="secondaryAction.icon" class="btn__ico"></lu-icon>
					{{ secondaryAction.label }}
				</button>
			</ng-container>
		</div>

		<div class="primary">
			<ng-container *ngIf="options.primaryActions">
				<button
					type="button"
					class="btn"
					[ngClass]="primaryAction.class || 'btn--default'"
					(click)="primaryAction.onClick()"
					*ngFor="let primaryAction of options.primaryActions"
					[disabled]="primaryAction.disabled">
					<lu-icon *ngIf="primaryAction.icon" [icon]="primaryAction.icon" class="btn__ico"></lu-icon>
					{{ primaryAction.label }}
				</button>
			</ng-container>
		</div>
	</footer>
</section>
